module.exports = __webpack_public_path__ + "img/mainLogo.759e7f62.png";